import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const features = [{
    name: 'Álbum 2026 PDF',
    basic: true,
    history: true
  }, {
    name: 'Figuritas todos los equipos',
    basic: true,
    history: true
  }, {
    name: 'Figuritas especiales',
    basic: true,
    history: true
  }, {
    name: 'Instructivo de impresión',
    basic: true,
    history: true
  }, {
    name: 'Álbum + Figuritas Qatar 2022',
    basic: false,
    history: true
  }, {
    name: 'Álbum + Figuritas Rusia 2018',
    basic: false,
    history: true
  }, {
    name: 'Álbum + Figuritas Sudáfrica 2010',
    basic: false,
    history: true
  }];
  return <section className="py-20 bg-gray-50" data-id="element-39">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-41">
          <h2 className="text-4xl md:text-5xl text-wc-dark mb-4" data-id="element-42">
            💰 RESUMEN DE LA OFERTA
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200" data-id="element-43">
          <div className="overflow-x-auto" data-id="element-44">
            <table className="w-full min-w-[600px]" data-id="element-45">
              <thead data-id="element-46">
                <tr className="bg-gray-100" data-id="element-47">
                  <th className="p-6 text-left text-lg font-bold text-gray-600 border-b border-gray-200 w-1/2" data-id="element-48">
                    Características
                  </th>
                  <th className="p-6 text-center text-xl font-display text-wc-blue border-b border-gray-200 w-1/4" data-id="element-49">
                    PACK BÁSICO
                  </th>
                  <th className="p-6 text-center text-xl font-display text-wc-yellow bg-wc-dark border-b border-gray-800 w-1/4" data-id="element-50">
                    PACK HISTÓRICO ⭐
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-51">
                {features.map((feat, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-52">
                    <td className="p-4 px-6 border-b border-gray-100 font-medium text-gray-800" data-id="element-53">
                      {feat.name}
                    </td>
                    <td className="p-4 border-b border-gray-100 text-center" data-id="element-54">
                      {feat.basic ? <Check className="w-6 h-6 text-green-500 mx-auto" data-id="element-55" /> : <X className="w-6 h-6 text-red-400 mx-auto" data-id="element-56" />}
                    </td>
                    <td className="p-4 border-b border-gray-100 text-center bg-gray-50/50" data-id="element-57">
                      {feat.history ? <Check className="w-6 h-6 text-green-500 mx-auto" data-id="element-58" /> : <X className="w-6 h-6 text-red-400 mx-auto" data-id="element-59" />}
                    </td>
                  </tr>)}
                <tr className="bg-gray-100" data-id="element-60">
                  <td className="p-6 font-bold text-gray-600 text-right" data-id="element-61">
                    PRECIO
                  </td>
                  <td className="p-6 text-center text-3xl font-display text-wc-blue" data-id="element-62">
                    $15.990
                  </td>
                  <td className="p-6 text-center text-3xl font-display text-wc-dark bg-wc-yellow" data-id="element-63">
                    $22.990
                  </td>
                </tr>
                <tr className="bg-white" data-id="element-64">
                  <td className="p-6" data-id="element-65"></td>
                  <td className="p-6 text-center" data-id="element-66">
                    <a href="https://www.digitalbibliotec.online/cart/52276163608858:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-wc-blue hover:bg-blue-800 text-white font-bold py-3 px-6 rounded-lg w-full transition-colors" data-id="element-67">
                      🛒 QUIERO EL PACK BASICO
                    </a>
                  </td>
                  <td className="p-6 text-center" data-id="element-68">
                    <a href="https://www.digitalbibliotec.online/cart/52276164100378:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-wc-red hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg w-full transition-colors shadow-md" data-id="element-69">
                      👑 QUIERO EL PACK HISTORICO
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}